import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Role} from '../_models/Role';
import {CreateRoleUserRequest} from '../_models/CreateRoleUserRequest';
import {firstValueFrom} from 'rxjs';

@Injectable({providedIn: 'root'})
export class RoleService {

  constructor(private http: HttpClient) { }

  getRoles() { return firstValueFrom(this.http.get<Role[]>(`${environment.localApiUrl}auth/Role/GetRoles`)); }

  getUserRoles(userName: string) { return firstValueFrom(this.http.get<Role[]>(`${environment.localApiUrl}auth/Role/GetRoleUser?username=${userName}`));}

  createRole(role: Role) { return firstValueFrom(this.http.post<Role>(`${environment.localApiUrl}auth/Role/CreateRole`, role)); }

  updateRole(role: Role) { return firstValueFrom(this.http.post<Role>(`${environment.localApiUrl}auth/Role/UpdateRole`, role)); }

  deleteRole(roleName: string) { return firstValueFrom(this.http.post<number>(`${environment.localApiUrl}auth/Role/DeleteRole`, {roleName})); }

  createUserRoles(accountRole: CreateRoleUserRequest) { return firstValueFrom(this.http.post<number>(`${environment.localApiUrl}auth/Role/CreateRoleUser`, accountRole)); }

  deleteRoleUser(accountRole: CreateRoleUserRequest) { return firstValueFrom(this.http.post<number>(`${environment.localApiUrl}auth/Role/DeleteRoleUser`, accountRole)); }
}
